<router-outlet></router-outlet>
<app-debug-panel *ngIf="showDebugTools"></app-debug-panel>
